/* FAETTON SAFE INSTANT PERCEPTION — no PJAX, no DOM swap, Kaching/apps safe */
(function(){
  'use strict';
  var prefetched = Object.create(null);
  var isTouch = false;
  function isModifiedClick(e){ return e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0; }
  function normalize(url){ try{ return new URL(url, location.href); }catch(e){ return null; } }
  function isSafeProductUrl(url){
    var u = normalize(url); if(!u) return false;
    if(u.origin !== location.origin) return false;
    if(u.search && /(^|[?&])variant=/.test(u.search)) return false;
    if(/\/cart|\/checkout|\/account|\/admin|\/apps|\/search/.test(u.pathname)) return false;
    return /\/products\//.test(u.pathname);
  }
  function prefetch(url){
    var u = normalize(url); if(!u || !isSafeProductUrl(u.href)) return;
    var key = u.href.split('#')[0];
    if(prefetched[key]) return;
    prefetched[key] = true;
    try{
      var l = document.createElement('link');
      l.rel = 'prefetch';
      l.as = 'document';
      l.href = key;
      l.fetchPriority = 'high';
      document.head.appendChild(l);
    }catch(e){}
    if('fetch' in window && 'requestIdleCallback' in window){
      requestIdleCallback(function(){
        try{ fetch(key, {mode:'no-cors', credentials:'same-origin', priority:'low', keepalive:false}).catch(function(){}); }catch(e){}
      }, {timeout:1200});
    }
  }
  function closestProductLink(target){ return target && target.closest ? target.closest('a[href*="/products/"]') : null; }
  document.addEventListener('mouseover', function(e){ if(isTouch) return; var a=closestProductLink(e.target); if(a) prefetch(a.href); }, {passive:true});
  document.addEventListener('focusin', function(e){ var a=closestProductLink(e.target); if(a) prefetch(a.href); }, {passive:true});
  document.addEventListener('touchstart', function(e){ isTouch = true; var a=closestProductLink(e.target); if(a) prefetch(a.href); }, {passive:true});
  document.addEventListener('pointerdown', function(e){ var a=closestProductLink(e.target); if(a) prefetch(a.href); }, {passive:true});

  /* Visual transition only. Navigation remains native, so Shopify apps/Kaching boot normally on the destination page. */
  document.addEventListener('click', function(e){
    var a = closestProductLink(e.target);
    if(!a || isModifiedClick(e) || !isSafeProductUrl(a.href)) return;
    if(a.target && a.target !== '_self') return;
    prefetch(a.href);
    document.documentElement.classList.add('faetton-transitioning');
    try{ sessionStorage.setItem('faetton:last_product_nav', String(Date.now())); }catch(err){}
  }, true);

  window.addEventListener('pageshow', function(){
    document.documentElement.classList.remove('faetton-transitioning');
    try{
      var t = parseInt(sessionStorage.getItem('faetton:last_product_nav') || '0', 10);
      if(t && Date.now() - t < 6000) document.documentElement.classList.add('faetton-arrived-from-prefetch');
      setTimeout(function(){ document.documentElement.classList.remove('faetton-arrived-from-prefetch'); }, 500);
    }catch(e){}
  });

  /* Back button for overlays/drawers without hijacking page navigation */
  var overlayState = false;
  function anyOpen(){ return document.querySelector('.js-ajax-cart-drawer.is-open,.ajax-cart__drawer.is-open,.js-ajax-cart-overlay.is-open,.upsell-popup:not(.hidden),.recommended-popup.is-open,.menu-drawer.is-open,.search-drawer.is-open,#CartDrawer.showsearch,.size-guide-open'); }
  function closeOverlays(){
    document.querySelectorAll('.js-ajax-cart-drawer.is-open,.ajax-cart__drawer.is-open').forEach(function(el){el.classList.remove('is-open');});
    document.querySelectorAll('.js-ajax-cart-overlay.is-open,.ajax-cart__overlay.is-open').forEach(function(el){el.classList.remove('is-open');});
    document.querySelectorAll('.recommended-popup.is-open').forEach(function(el){el.classList.remove('is-open');});
    document.querySelectorAll('.upsell-popup:not(.hidden)').forEach(function(el){el.classList.add('hidden');});
    document.querySelectorAll('#CartDrawer.showsearch').forEach(function(el){el.classList.remove('showsearch');});
    document.documentElement.classList.remove('is-locked','size-guide-open');
    document.body.classList.remove('size-guide-open');
    document.body.style.overflowY=''; document.body.style.position='';
  }
  document.addEventListener('click', function(){
    setTimeout(function(){
      if(anyOpen() && !overlayState){ overlayState = true; try{ history.pushState({faettonOverlay:true}, ''); }catch(e){} }
    }, 40);
  }, true);
  window.addEventListener('popstate', function(e){
    if(overlayState && anyOpen()){
      closeOverlays(); overlayState = false;
      if(e.preventDefault) e.preventDefault();
    }
  });

  /* Size guide emergency binding: handles pages where inline size guide missed its binding. */
  document.addEventListener('click', function(e){
    var trigger = e.target.closest && e.target.closest('.open-size-guide,[data-size-guide-open],a[href^="#size-chart"],a[href*="size-chart"]');
    if(!trigger) return;
    var target = null;
    var href = trigger.getAttribute('href') || trigger.getAttribute('data-size-guide-open') || '';
    if(href && href.indexOf('#') >= 0) target = document.querySelector(href.slice(href.indexOf('#')));
    if(!target) target = document.querySelector('.js-sizechart-lightbox,[id^="size-chart"],[id^="sizeGuideOverlay-"]');
    if(target){
      e.preventDefault();
      target.style.display = target.id && target.id.indexOf('sizeGuideOverlay-') === 0 ? 'flex' : 'block';
      target.classList.add('is-open');
      document.documentElement.classList.add('size-guide-open');
      document.body.classList.add('size-guide-open');
    }
  }, true);
  document.addEventListener('click', function(e){
    if(e.target.closest && e.target.closest('.sizeGuideCloseBtn,.js-sizechart-lightbox .close,.size-chart-close')){
      document.querySelectorAll('.js-sizechart-lightbox,[id^="size-chart"],[id^="sizeGuideOverlay-"]').forEach(function(el){ el.style.display='none'; el.classList.remove('is-open'); });
      document.documentElement.classList.remove('size-guide-open'); document.body.classList.remove('size-guide-open');
    }
  }, true);
})();

/* FAETTON FINAL PATCH: safe perceived-instant navigation + delegated cart upsell flyout. */
(function(){
  'use strict';

  function normalize(url){ try { return new URL(url, location.href); } catch(e){ return null; } }
  function isSafeProductUrl(url){
    var u = normalize(url); if(!u) return false;
    if(u.origin !== location.origin) return false;
    if(u.search && /(^|[?&])variant=/.test(u.search)) return false;
    if(/\/cart|\/checkout|\/account|\/admin|\/apps|\/search/.test(u.pathname)) return false;
    return /\/products\//.test(u.pathname);
  }
  window.FaettonPrefetched = window.FaettonPrefetched || Object.create(null);
  function prefetchDocument(url, priority){
    var u = normalize(url); if(!u || !isSafeProductUrl(u.href)) return;
    var key = u.href.split('#')[0];
    if(window.FaettonPrefetched[key]) return;
    window.FaettonPrefetched[key] = true;
    try {
      var l = document.createElement('link');
      l.rel = 'prefetch';
      l.as = 'document';
      l.href = key;
      if(priority) l.fetchPriority = priority;
      document.head.appendChild(l);
    } catch(e) {}
  }

  function prefetchVisibleProducts(){
    var links = Array.prototype.slice.call(document.querySelectorAll('a[href*="/products/"]')).slice(0, 12);
    if(!links.length) return;
    if('IntersectionObserver' in window){
      var count = 0;
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(!entry.isIntersecting || count >= 10) return;
          var a = entry.target;
          count += 1;
          prefetchDocument(a.href, 'low');
          io.unobserve(a);
        });
      }, {rootMargin:'450px 0px'});
      links.forEach(function(a){ io.observe(a); });
    } else {
      links.slice(0, 6).forEach(function(a){ prefetchDocument(a.href, 'low'); });
    }
  }
  if(document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prefetchVisibleProducts, {once:true});
  } else {
    prefetchVisibleProducts();
  }

  function openUpsellFlyoutById(id, sourceButton){
    if(!id) return false;
    var flyout = document.getElementById(id);
    if(!flyout && id.indexOf('prod_') === 0) {
      var productId = id.split('--')[0].replace('prod_', '');
      flyout = document.querySelector('.flyout-section[data-prodid="' + productId + '"]');
    }
    if(!flyout) return false;
    flyout.classList.add('open');
    document.body.classList.add('minicart-hide');
    document.body.style.overflowY = 'hidden';
    var sticky = document.getElementById('sticky');
    if(sticky) sticky.classList.remove('show');
    document.querySelectorAll('.header_group').forEach(function(el){ el.classList.add('hidden'); });
    try { sourceButton && sourceButton.blur && sourceButton.blur(); } catch(e) {}
    return true;
  }

  document.addEventListener('click', function(e){
    var btn = e.target.closest && e.target.closest('.ajax-cart-drawer__content .upsell-mprod .action_btn button, .ajax-cart__drawer .upsell-mprod .action_btn button, .up-sell-left .upsell-mprod .action_btn button');
    if(!btn) return;
    var id = btn.getAttribute('data-id');
    if(openUpsellFlyoutById(id, btn)) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  document.addEventListener('click', function(e){
    var close = e.target.closest && e.target.closest('.flyout_close');
    if(!close) return;
    var flyout = close.closest('.flyout-section');
    if(!flyout) return;
    flyout.classList.remove('open');
    document.body.classList.remove('minicart-hide');
    document.body.style.overflowY = '';
    var sticky = document.getElementById('sticky');
    if(sticky) sticky.classList.add('show');
    document.querySelectorAll('.header_group').forEach(function(el){ el.classList.remove('hidden'); });
  }, true);
})();
